import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    data () {

    },
    created: function () {

    },
    computed: {
        ...mapGetters({
            users: 'data/users',
        }),
        years () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1900}, (value, index) => 1901 + index).reverse()
        }
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment(String(value)).format('MM/DD/YYYY')
            }
        },
        getUsername(id) {
            let users = this.users.filter(user => {
              return user.id == id
            })

            if(users.length > 0) {
                return users[0].name
            } else {
                return ''
            }
        }
    }
 }